import { render, staticRenderFns } from "./DeliveryNotificationNew.vue?vue&type=template&id=e53d233a&scoped=true&"
import script from "./DeliveryNotificationNew.vue?vue&type=script&lang=js&"
export * from "./DeliveryNotificationNew.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryNotificationNew.vue?vue&type=style&index=0&id=e53d233a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e53d233a",
  null
  
)

export default component.exports